// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e008132a","239":"1112d3e8","732":"78233614"}[chunkId] + ".chunk.js";
};